var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-bottom":"20px"}},[_c('p',{staticClass:"ai_title"},[_vm._v(_vm._s(_vm.ai_title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }